import { createTheme } from '@mui/material'
import { blue, green, red } from '@mui/material/colors'
import { TypographyOptions } from '@mui/material/styles/createTypography'
import type {} from '@mui/lab/themeAugmentation'

const palette = {
  primary: {
    dark: '#050921',
    light: '#265DA5',
    main: '#1d477f',
  },
  action: {
    disabledBackground: '#cdced3',
    disabled: '#717381',
  },
  secondary: {
    main: '#0C2C53',
    light: '#748AAF',
    contrastText: '#fff',
  },
  error: {
    light: '#FF3B30',
    main: red.A400,
  },
  info: {
    dark: '#282828',
    main: blue.A400,
  },
  success: {
    light: '#34C759',
    main: green[800],
  },
  warning: {
    main: '#ff9500',
  },
  grey: {
    50: '#fafafa',
    100: '#f2f2f2',
    200: '#E5E6E8',
    400: '#717381',
    600: '#757575',
    900: '#050921',
  },
}

const typography: TypographyOptions = {
  fontFamily: 'Roboto, sans-serif',
  h1: {
    fontSize: '1.5rem',
    fontWeight: 500,
    letterSpacing: 0,
  },
  h2: {
    fontSize: '1.25rem',
    fontWeight: 500,
    letterSpacing: 0,
  },
  h3: {
    fontSize: '1rem',
    fontWeight: 500,
    letterSpacing: 0,
  },
  h4: {
    fontSize: '0.875rem',
    fontWeight: 500,
    letterSpacing: 0,
  },
  h5: {
    fontSize: '0.75rem',
    fontWeight: 500,
    letterSpacing: 0,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 500,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
}

const theme = createTheme({
  components: {
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          width: '100%',
          '.MuiCalendarPicker-viewTransitionContainer *': {
            fontSize: '0.875rem !important',
          },
          '& [role="row"]': {
            justifyContent: 'space-around',
          },
          '& .MuiCalendarPicker-viewTransitionContainer > div > div': {
            justifyContent: 'space-around',
          },
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected:focus': {
            backgroundColor: palette.primary.main,
          },
        },
        today: {
          '&:not(.Mui-selected)': {
            borderColor: palette.primary.main,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        text: {
          color: palette.primary.main,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            opacity: 0.35,
          },
        },
      },
    },
  },
  palette,
  typography,
})

export { theme }
